import { gql } from "@apollo/client";

export const SEAT_SWAP_PREVIEW = gql`
  query SeatSwapPreview($user1Id: ID!, $user2Id: ID!) {
    seatSwapPreview(user1Id: $user1Id, user2Id: $user2Id) {
      success
      errors
    }
  }
`; 